module.exports = __webpack_public_path__ + "static/media/homeDelivery.44e1602b.png";